/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { Memento } from "../model"
// @ts-ignore
import type { MementoInput } from "../model"
// @ts-ignore
import type { PdfLink } from "../model"
/**
 * MementoResourceV2Api - axios parameter creator
 */
export const MementoResourceV2ApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Generate memento pdf link by project id
     * @param {number} projectId
     * @param {string} timeZone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generatePdf2: async (
      projectId: number,
      timeZone: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("generatePdf2", "projectId", projectId)
      // verify required parameter 'timeZone' is not null or undefined
      assertParamExists("generatePdf2", "timeZone", timeZone)
      const localVarPath = `/v2.0/memento/{projectId}/pdf`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      if (timeZone !== undefined) {
        localVarQueryParameter["timeZone"] = timeZone
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get memento by project id
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMemento: async (
      projectId: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("getMemento", "projectId", projectId)
      const localVarPath = `/v2.0/memento/{projectId}`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update memento by project id
     * @param {number} projectId
     * @param {MementoInput} mementoInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateMemento: async (
      projectId: number,
      mementoInput: MementoInput,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("updateMemento", "projectId", projectId)
      // verify required parameter 'mementoInput' is not null or undefined
      assertParamExists("updateMemento", "mementoInput", mementoInput)
      const localVarPath = `/v2.0/memento/{projectId}`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        mementoInput,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * MementoResourceV2Api - functional programming interface
 */
export const MementoResourceV2ApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MementoResourceV2ApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Generate memento pdf link by project id
     * @param {number} projectId
     * @param {string} timeZone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async generatePdf2(
      projectId: number,
      timeZone: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdfLink>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.generatePdf2(
        projectId,
        timeZone,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MementoResourceV2Api.generatePdf2"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get memento by project id
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMemento(
      projectId: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Memento>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getMemento(projectId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MementoResourceV2Api.getMemento"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update memento by project id
     * @param {number} projectId
     * @param {MementoInput} mementoInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateMemento(
      projectId: number,
      mementoInput: MementoInput,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Memento>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateMemento(
        projectId,
        mementoInput,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["MementoResourceV2Api.updateMemento"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * MementoResourceV2Api - factory interface
 */
export const MementoResourceV2ApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = MementoResourceV2ApiFp(configuration)
  return {
    /**
     *
     * @summary Generate memento pdf link by project id
     * @param {MementoResourceV2ApiGeneratePdf2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generatePdf2(
      requestParameters: MementoResourceV2ApiGeneratePdf2Request,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PdfLink> {
      return localVarFp
        .generatePdf2(requestParameters.projectId, requestParameters.timeZone, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get memento by project id
     * @param {MementoResourceV2ApiGetMementoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMemento(
      requestParameters: MementoResourceV2ApiGetMementoRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Memento> {
      return localVarFp
        .getMemento(requestParameters.projectId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update memento by project id
     * @param {MementoResourceV2ApiUpdateMementoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateMemento(
      requestParameters: MementoResourceV2ApiUpdateMementoRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Memento> {
      return localVarFp
        .updateMemento(requestParameters.projectId, requestParameters.mementoInput, options)
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for generatePdf2 operation in MementoResourceV2Api.
 */
export interface MementoResourceV2ApiGeneratePdf2Request {
  readonly projectId: number

  readonly timeZone: string
}

/**
 * Request parameters for getMemento operation in MementoResourceV2Api.
 */
export interface MementoResourceV2ApiGetMementoRequest {
  readonly projectId: number
}

/**
 * Request parameters for updateMemento operation in MementoResourceV2Api.
 */
export interface MementoResourceV2ApiUpdateMementoRequest {
  readonly projectId: number

  readonly mementoInput: MementoInput
}

/**
 * MementoResourceV2Api - object-oriented interface
 */
export class MementoResourceV2Api extends BaseAPI {
  /**
   *
   * @summary Generate memento pdf link by project id
   * @param {MementoResourceV2ApiGeneratePdf2Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public generatePdf2(
    requestParameters: MementoResourceV2ApiGeneratePdf2Request,
    options?: RawAxiosRequestConfig
  ) {
    return MementoResourceV2ApiFp(this.configuration)
      .generatePdf2(requestParameters.projectId, requestParameters.timeZone, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get memento by project id
   * @param {MementoResourceV2ApiGetMementoRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getMemento(
    requestParameters: MementoResourceV2ApiGetMementoRequest,
    options?: RawAxiosRequestConfig
  ) {
    return MementoResourceV2ApiFp(this.configuration)
      .getMemento(requestParameters.projectId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update memento by project id
   * @param {MementoResourceV2ApiUpdateMementoRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateMemento(
    requestParameters: MementoResourceV2ApiUpdateMementoRequest,
    options?: RawAxiosRequestConfig
  ) {
    return MementoResourceV2ApiFp(this.configuration)
      .updateMemento(requestParameters.projectId, requestParameters.mementoInput, options)
      .then(request => request(this.axios, this.basePath))
  }
}
